import styled from "@emotion/styled";

import { ContentShareWidget } from "~/components/content/content-share-widget";

export const Container = styled.aside`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: min-content;
`;

export type ContentShareWidgetProps = {
  $direction: "column" | "row";
};

export const StyledContentShareWidget = styled(ContentShareWidget)<ContentShareWidgetProps>`
  display: flex;
  flex-flow: ${props => props.$direction};
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
`;
